import React, { useState, useRef, useEffect } from "react";
import "./uploadDocument.css";
import { Field, Form, Formik } from "formik";
import logoutimg from "../../../assets/logout.png";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  distributorLogoUpload,
  logout,
} from "../../../redux/actions/authActions";
import uploadDoc from "../../../assets/uploadDoc.svg";
import reupload from "../../../assets/reUpload.svg";
import { Document, Page, pdfjs } from "react-pdf";
import SkipModal from "../../../components/modals/skipModal";
import ErrorPopup from "../../../components/Popups/ErrorPopup";
import SuccessPopup from "../../../components/Popups/SuccessPopUp";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const UploadProfileImage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [skipShow, setSkipShow] = useState(false);
  const [images, setImages] = useState([]);
  const [img, setImg] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [showSuccessPopup1, setShowSuccessPopup1] = useState(false);
  const [showSuccessMsg1, setShowSuccessMsg1] = useState("");

  useEffect(() => {
    if (img != null && img.trim() != "") {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [img]);

  const imageUpdateOne = (file) => {
    console.log(file.target.files[0]);
    setLoading(true);
    // data for submit
    dispatch(
      distributorLogoUpload(
        file.target.files[0],
        onImageUploadSuccess,
        onImageUploadError
      )
    );

    // setImages(imageList);
    // formik.setFieldValue("imageFront", imageList);
  };

  const onImageUploadSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setImg(data.data.data.filePath);
  };

  const onImageUploadError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const initialValues = {
    profileImage: "",
  };
  const loginSchema = Yup.object().shape({
    // profileImage: Yup.mixed().required("Upload an Image"),
  });
  const onSubmit = (values, { resetForm }) => {
    // resetForm();
    console.log(location, img);
    let dispatchData = location.state;
    dispatchData["logo"] = img;

    navigate("/upload-document-drug-license", {
      state: dispatchData,
    });
    console.log(dispatchData, "imgdata");
  };

  const skipFnc = () => {
    let dispatchData = location.state;
    dispatchData["logo"] = null;

    navigate("/upload-document-drug-license", {
      state: dispatchData,
    });
    console.log(dispatchData);
  };

  const [file, setFile] = useState();
  function handleChange(e) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc1 = () => {
    setShowSuccessPopup1(false);
    navigate("/login");
  };

  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup1(true);
    const message1 = data.data.message;
    const msg_updated1 = message1.charAt(0).toUpperCase() + message1.slice(1);
    setShowSuccessMsg1(msg_updated1);
    setTimeout(timeOutFnc1, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <div className="upload-main-container  d-flex justify-content-center align-items-center">
      <div className="upload-gst-form-container col-10 col-md-6 px-2  mx-auto my-2 py-3  ">
        <div className="d-flex justify-content-between px-3 mx-2 mt-3">
          <div>
            <label className="fw_500 fn_Nunito fs_20 fs_md_18 fs_sm_16">
              Upload Your Logo
            </label>
          </div>
          <div
            className="d-flex align-items-center mb-md-3 cursor_pointer"
            onClick={() => logoutHandler()}
          >
            <span className="fs_12 fs_sm_12  fw_600 color_2ad3e7">Logout</span>
            <img className="mx-1" src={logoutimg} height="12px" />
          </div>
        </div>
        <div className=" px-3 mx-2">
          <p className="fs_11  col-5 pe-4 col-sm-10 fn_Nunito color_b0b3c7 ">
            Kindly upload your logo
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={loginSchema}
        >
          {({ formik, handleChange, values, setFieldValue }) => {
            return (
              <Form className="">
                <div className="mt-4">
                  <div className=" mx-2">
                    <div className="mx-4 ps-3 my-2">
                      <div
                        className="d-flex justify-content-between align-items-end"
                        style={{ maxWidth: "450px" }}
                      >
                        <label className="fs_14">Your Logo</label>
                        {img !== "" && img !== null && (
                          <>
                            <label
                              htmlFor="DrugLicense"
                              style={{ textTransform: "uppercase" }}
                              className="fs_12 me-2 Medium_Purple fw_700 align-items-center"
                            >
                              <img src={reupload} className="mb-1" /> Re-UPload
                            </label>
                          </>
                        )}
                      </div>
                      <input
                        type="file"
                        name="upload"
                        id="DrugLicense"
                        accept="image/png,image/jpeg"
                        style={{ display: "none" }}
                        onChange={imageUpdateOne}
                      />

                      {img !== "" && img !== null ? (
                        <div
                          className={` h-100`}
                          style={{
                            height: "25rem",
                            overflowY: "scroll",
                            overflowX: "hidden",
                            scrollBehavior: "smooth",
                          }}
                        >
                          <div className="doc-upload-container">
                            <img src={img} width="100%" height="100%" />
                          </div>
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor="DrugLicense"
                            className="w-100"
                            // style={{ width: "500px" }}
                          >
                            <div className="doc-upload-container w-100 text-center">
                              <img src={uploadDoc} alt="doc" className="mt-5" />
                              <p className="Medium_Purple fw_700 my-1 fs_17">
                                Choose File
                              </p>
                              <p className="color_b0b3c7 fs_12">
                                Supports: jpeg and png files only
                              </p>
                            </div>
                          </label>
                          <input
                            type="file"
                            name="upload"
                            id="DrugLicense"
                            accept="image/png,image/jpeg"
                            onChange={imageUpdateOne}
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  <div className="d-flex justify-content-center px-lg-4 mx-lg-2 me-lg-3 my-4 py-2 gap-2">
                    <button
                      className="upload-skip-button col-12 mx-3"
                      type="button"
                      onClick={() => setSkipShow(true)}
                      // disabled={disable}
                    >
                      SKIP
                    </button>
                    <button
                      className="upload-next-button col-12"
                      type="submit"
                      disabled={disable}
                    >
                      {loading && <Spinner size="sm" />}
                      Next
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        <SkipModal
          titel="Profile Image"
          show={skipShow}
          handleClose={() => setSkipShow(false)}
          skipFnc={skipFnc}
        />
        <ErrorPopup
          show={showErrorPopup}
          setSkipShowtitle={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </div>
  );
};

export default UploadProfileImage;
